<template>
  <div class="full-height">
    <crud-layout
      ref="crudLayout"
      v-if="!reportForms"
      :name="name"
      :interface="nmInterface"
      :pageDetail="pageDetail"
      :page-search="pageSearch"
      :label="test"
      :id="id"
      :page="page"
      @page-added="pageAdded"
      :minimizeTabs="true"/>
    <billing-order-export-report
      v-else
      @on-close="onCloseReport"
      :format="reportFormat"
      :forms="reportForms"
    />
    <q-dialog v-model="visible" persistent>
      <q-card>
        <q-card-section class="row justify-center q-mx-lg">
          <span class="text-subtitle1 text-weight-medium text-center">{{
            $gettext("REPORT_SELECTION")
          }}</span>
        </q-card-section>
        <q-card-section class="row justify-center q-mx-lg">
          <q-radio v-model="reportFormat" val="pdf" label="PDF" />
          <q-radio v-model="reportFormat" val="xls" label="Excel" />
        </q-card-section>
        <q-card-actions class="justify-center q-pa-md q-my-sm">
          <q-btn
            :label="$gettext('CANCEL')"
            color="grey-7"
            v-close-popup
            class="q-px-lg"
          />
          <q-btn
            :label="$gettext('GENERATE')"
            color="info"
            v-close-popup
            @click="openDialogReport"
            class="q-px-lg"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="visibleExporteJde" persistent>
      <q-card>
        <q-card-section class="row justify-center">
          <q-icon name="error_outline" color="warning" size="4.5em"></q-icon>
        </q-card-section>
        <q-card-section class="row justify-center q-mx-lg">
          <span class="text-subtitle1 text-weight-medium text-center">{{
            $gettext("EXPORT_JDE_CONFIRM")
          }}</span>
        </q-card-section>
        <q-card-actions class="justify-center q-pa-md q-my-sm">
          <q-btn
            :label="$gettext('DIALOGS_NO')"
            color="grey-7"
            v-close-popup
            class="q-px-lg"
          />
          <q-btn
            :label="$gettext('DIALOGS_YES')"
            color="info"
            v-close-popup
            @click="exportJde"
            class="q-px-lg"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <jde-status-selection-modal
      ref="jdeStatusModal"
      :params="pageParams"
      :show="showJdeStatusModal"
      @update:model-value="(val) => (showJdeStatusModal = val)"
    />
    <billing-order-concession-modal
      v-if="modalSub && modalSub.show"
      :show="modalSub.show"
      :forms="modalSub.forms"
      :label="modalSub.label"
      :data="modalSub.data"
      :fields="modalSub.fields"
      :parent="modalSub.parent"
      :params="modalSub.params"
      :detail="modalSub.detail"
      @action-button="actionButtonModalSub"
      @input="(val) => (modalSub.show = val)"
    />
  </div>
</template>
<script>
import BillingOrderMethodsComunicate from './BillingOrderMethodsComunicate'
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import BillingOrderActionPageDetail from './BillingOrderActionPageDetail'
import BillingOrderActionPage from './BillingOrderActionPage'
import BillingOrderActionPageSearch from './BillingOrderActionPageSearch.vue'
import BillingOrderPage from '../billingOrder/BillingOrderPage.vue'
import BillingOrderConcessionPage from '../billingOrder/BillingOrderConcessionPage'
import BillingOrderConcessionModal from '../billingOrder/BillingOrderConcessionModal'
import BillingOrderExportReport from '../report/BillingOrderExportReport.vue'
import BillingOrderReport from '../report/BillingOrderReport.vue'
import BillingOrderBatchReportCrudLayout from './BillingOrderBatchReportCrudLayout.vue'
import { repository, messageBox } from 'jtech'
import BillingOrderModel from './state/BillingFiltersState'
import JdeStatusSelectionModal from './JdeStatusSelectionModal.vue'

const CrudLayout = JtCrud.CrudLayout

@Component({
  name: 'BillingOrderAction',
  components: {
    CrudLayout,
    BillingOrderActionPage,
    BillingOrderConcessionModal,
    BillingOrderPage,
    BillingOrderExportReport,
    BillingOrderReport,
    JdeStatusSelectionModal
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class BillingOrderAction extends Vue {
  visible = false;
  visibleExporteJde = false;
  reportFormat = 'pdf';
  reportParams = null;
  reportForms = null;
  exportJdeData = null;
  showJdeStatusModal = false;
  state = BillingOrderModel.getInstance();
  pageParams = {};
  modalSub= { show: false };

  mounted () {
    try {
      this.$refs.crudLayout.onButton('btNovo', this.gravar)
      this.$refs.crudLayout.onButton('btNovoConcession', this.btNovoConcession)
      this.$refs.crudLayout.onButton(
        'btAnalyzeConcession',
        this.btAnalyzeConcession
      )
      this.$refs.crudLayout.onButton(
        'btAnalyzeConcessionInvoices',
        this.btAnalyzeConcessionInvoices
      )
      this.$refs.crudLayout.onButton('exportJde', this.jdeDialogShow)
      this.$refs.crudLayout.onButton('impStatusJde', this.impStatusJde)
      this.$refs.crudLayout.onButton('btSendMeasurement', this.sendMeasurement)
      this.$refs.crudLayout.onButton(
        'updateJdeStatus',
        this.openJdeStatusModal
      )
      this.$refs.crudLayout.onButton('btGerarExportados', this.generate)
      this.$refs.crudLayout.onButton('btRefresh', this.refreshButton)
      BillingOrderMethodsComunicate.$on('refresh-grid', (e) => {
        e.refresh()
      })
    } catch (error) {
      console.error(error)
    }
  }

  updated () {
    try {
      this.$refs.crudLayout.onButton('btNovo', this.gravar)
      this.$refs.crudLayout.onButton('exportJde', this.jdeDialogShow)
      this.$refs.crudLayout.onButton('impStatusJde', this.impStatusJde)
      this.$refs.crudLayout.onButton('btSendMeasurement', this.sendMeasurement)
      this.$refs.crudLayout.onButton(
        'updateJdeStatus',
        this.openJdeStatusModal
      )
      this.$refs.crudLayout.onButton('btGerarExportados', this.generate)
      this.$refs.crudLayout.onButton('btRefresh', this.refresh)
    } catch (error) {}
  }

  openJdeStatusModal ({ page }) {
    this.pageParams = page.$refs.jtDataTable
    this.showJdeStatusModal = true
  }

  onCloseReport () {
    this.reportForms = null
  }

  pageAdded (pageAdded) {
    if (pageAdded.name == 'btPesquisar') {
      this.loadTabs()
    }
  }

  async loadTabs () {
    if (this.$refs.crudLayout.containerData.pages.length == 1) {
      this.$refs.crudLayout.addPage({
        name: this.$gettext('GENERATION_HISTORY'),
        label: this.$gettext('GENERATION_HISTORY'),
        icon: 'mdi-file-plus',
        nmInterface: 'billingOrderReport.billingOrderReport',
        interface: 'billingOrderReport.billingOrderReport',
        component: this.billingOrderReport,
        flClose: false
      })
      this.$refs.crudLayout.addPage({
        name: this.$gettext('EXPORTATION_HISTORY_BATCH'),
        label: this.$gettext('EXPORTATION_HISTORY'),
        icon: 'mdi-file-export',
        component: BillingOrderBatchReportCrudLayout,
        flClose: false
      })
      this.$refs.crudLayout.setPage('btPesquisar')
    }
  }

  async openDialogReport () {
    const idParam = { relFormatoRelatorio: this.relFormatoRelatorio }
    const repoForm = await repository.resolve(
      'billingOrderExportReport.billingOrderExportReport',
      idParam
    )
    repoForm[0].dadosForm = { ...repoForm[0].dadosForm, ...idParam }
    this.reportForms = repoForm
  }

  generate () {
    this.visible = true
  }

  jdeDialogShow ({ button, params, page, controller }) {
    this.exportJdeData = { button, page }
    this.visibleExporteJde = true
  }

  async gravar ({ button, params, page, controller }) {
    const forms = await repository.resolve('billingOrder.gravar')
    forms[0].inputs
      .filter((x) => x.name == 'composicao.composicao')[0]
      .buttons.splice(1, 1)
    this.$refs.crudLayout.addPage({
      label: button.label,
      forms: forms,
      params: forms[0].dadosForm,
      component: this.billingOrderPage,
      flClose: true
    })
  }

  async btNovoConcession ({ button, params, page, controller }) {
    const forms = await repository.resolve(button.action)
    this.$refs.crudLayout.addPage({
      label: button.label,
      forms: forms,
      params: forms[0].dadosForm,
      component: BillingOrderConcessionPage,
      flClose: true
    })
  }

  async btAnalyzeConcession ({ button, params, page, controller }) {
    const forms = await repository.resolve(button.action, params)
    page.setData('contracts', forms[0].relacionamentos.contracts)
    page.setData('invoices', forms[0].relacionamentos.invoices)
  }

  async btAnalyzeConcessionInvoices ({ button, params, page, controller }) {
    this.modalSub = {
      show: true,
      label: button.label,
      forms: page.forms,
      fields: page.getColumns('invoices'),
      data: params.invoices,
      params: params,
      parent: page
    }
  }

  async exportJde () {
    await repository.resolveLogic(this.exportJdeData.button.action, {
      billingOrders: this.exportJdeData.page.$refs.jtDataTable.selected
    })
    this.exportJdeData.page.refresh()
  }

  async sendMeasurement ({ page }) {
    const ordersEdited = page.$refs.jtDataTable.selected
      .filter((billingOrder) => !billingOrder.automatic)
      .map((billingOrder) => billingOrder.id)
    if (ordersEdited.length != 0) {
      const ordersString = ordersEdited.join(',')
      messageBox.warn(
        this.$gettextInterpolate(this.$gettext('ITEMS_EDITED_BILLING_ORDER'), {
          items: ordersString
        })
      )
      return
    }

    const resolveParams = {
      ids: page.$refs.jtDataTable.selected.map(
        (billingOrder) => billingOrder.id
      )
    }
    await repository.resolveLogic(
      'billingOrder.sendMeasurement',
      resolveParams
    )
    page.$refs.jtDataTable.selected.splice(
      0,
      page.$refs.jtDataTable.selected.length
    )
    page.refresh()
  }

  refresh ({ page }) {
    page.refresh()
  }

  refreshButton ({ page }) {
    this.state.setFilters({})
    BillingOrderMethodsComunicate.$emit('refresh-data-table')
  }

  async impStatusJde ({ button, params, page, controller }) {
    const forms = await repository.resolveLogic(button.action, params)
  }

  get billingOrderExportReport () {
    return BillingOrderExportReport
  }

  get billingOrderPage () {
    return BillingOrderPage
  }

  get billingOrderReport () {
    return BillingOrderReport
  }

  get nmInterface () {
    return this.interface
  }

  get relFormatoRelatorio () {
    return this.reportFormat === 'pdf' ? 1 : 3
  }

  get page () {
    return BillingOrderActionPage
  }

  get pageDetail () {
    return BillingOrderActionPageDetail
  }

  get pageSearch () {
    return BillingOrderActionPageSearch
  }
}
export default BillingOrderAction
</script>
<style lang="stylus" scoped></style>
